import { render, staticRenderFns } from "./SubTitle.vue?vue&type=template&id=9fddcb24&scoped=true&"
import script from "./SubTitle.vue?vue&type=script&lang=js&"
export * from "./SubTitle.vue?vue&type=script&lang=js&"
import style0 from "./SubTitle.vue?vue&type=style&index=0&id=9fddcb24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fddcb24",
  null
  
)

export default component.exports